<template>
  <div class="user_wrap">
    <div
      style="width: 96%;
    margin-left: 2%;margin-top: 16px;border-radius: 14px;box-shadow: 0 0 80px rgba(0, 0, 0, 0.8);  background: #141418 !important;padding: 16px;"
    >
      <div style="display: flex;align-items: center;gap: 12px;">
        <div style="position: relative;width: 50px;height: 50px;flex-shrink: 0;">
          <img
            :src="data.user_icon"
            alt=""
            style="width: 50px;height: 50px;border-radius: 50%;"
          >
        </div>
        <div style="flex: 1;min-width: 0;">
          <div style="color:#fff;font-size: 24px;font-weight: 800;line-height: 1.15;letter-spacing: .3px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            {{ data.username }}
          </div>
          <div style="margin-top: 8px;display: flex;align-items: center;gap: 6px;flex-wrap: wrap;">
            <span style="display: inline-block;padding: 0 10px;line-height: 22px;font-size: 13px;border-radius: 11px;color: #2e78ff;border: 1px solid #cfe0fa;background: #f3f8ff;">
              UID:{{ data.uid }}
            </span>
            <span style="margin-top: 0;display: inline-block;padding: 0 8px;line-height: 18px;font-size: 11px;border-radius: 9px;color: #0f1e4b;color: #8a5b09;background: linear-gradient(90deg, #ffe2a9, #ffc96b);">
              {{ data.vip_name }}
            </span>
          </div>
        </div>
      </div>
      <div style="margin-top: 14px;text-align: center;">
        <div style="margin-top: 14px;justify-content: center;display: flex;gap: 8px;">
          <div
            style="width: 48%;margin-left: 1%;float: left;height: 60px;background: #3775f4;border-radius: 10px;line-height: 30px;text-align: center;color: #fff;"
            @click="$router.push('/recharge')"
          >
            <div>{{ $t('utils.lunlog42') }}</div>
            <div>{{ common.currency_symbol_basic() }}{{ common.precision_basic(money_r) }}</div>
          </div>
          <div
            style="width: 48%;margin-right: 1%;float: right;height: 60px;background: #ff5722;border-radius: 10px;line-height: 30px;text-align: center;color: #fff;"
            @click="$router.push('/withdraw')"
          >
            <div>{{ $t('utils.lunlog43') }}</div>
            <div>{{ common.currency_symbol_basic() }}{{ common.precision_basic(fundBalanceUsd) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="block_div flex_center user_yw"
      style="padding: 6px 0px;box-shadow: 0 0 80px rgba(0, 0, 0, 0.8); margin-top: 10px; background: #141418 !important;color:#fff"
    >
      <div @click="$router.push('/invest/record')">
        <img
          src="../img/user/order.png"
          alt=""
        >
        <p>{{ $t('user.inviteRecord') }}</p>
      </div>
	  <div @click="$router.push('/team')">
	    <img
	      src="../img/home/team_cur.png"
	      alt=""
	    >
	    <p>{{ $t('home.team') }}</p>
	  </div>
      <div @click="$router.push('/funding/record')">
        <img
          src="../img/user/detailss.png"
          alt=""
        >
        <p>{{ $t('user.fundingDetails') }}</p>
      </div>
    </div>
    <div
      class="block_div  work_box"
      style="box-shadow: 0 0 80px rgba(0, 0, 0, 0.8); margin-top: 10px; background: #141418 !important;"
    >
      <!-- <div style="margin-bottom: 7px;color: #2e78ff;font-size: 16px;font-weight: 700;line-height: 30px;">
						{{app.name}}
					</div>
					<div style="margin-bottom: 8px;color: #fff;font-size: 14px;font-weight: 600;line-height: 30px;">
						{{$t('utils.lunlog47')}}
					</div>
					<div style="display: block;color: rgba(101, 127, 255, 0.54);font-size: 12px;line-height: 19px;margin-bottom: 15px;">
						{{$t('utils.lunlog48')}}
					</div> -->
      <div class="flex_center">
        <div
          class="item"
          @click="jump('/recharge')"
        >
          <div class="item_img">
            <img
              :src="require('../img/index/receive.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.recharge') }}
          </p>
        </div>
						
        <div
          class="item"
          @click="jump('/withdraw')"
        >
          <div class="item_img">
            <img
              :src="require('../img/index/send.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.withdraw') }}
          </p>
        </div>
						
						
        <div
          class="item"
          @click="$router.push('/vip')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/vip.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.vip') }}
          </p>
        </div>
        <div
          class="item"
          @click="$router.push('/rewards')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/rewards.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.rewards') }}
          </p>
        </div>
        <div
          class="item"
          @click="$router.push('/recharge/record')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/recharge.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.rechargeRecord') }}
          </p>
        </div>
        <div
          class="item"
          @click="$router.push('/withdraw/record')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/cash.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.withdrawRecord') }}
          </p>
        </div>
			
        <div
          class="item"
          @click="$router.push('/wallet')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/moneybag.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.withdrawAccount') }}
          </p>
        </div>
			
        <div
          class="item"
          @click="$router.push('/setpwd')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/secret.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('utils.lunlog19') }}
          </p>
        </div>
			
        <div
          class="item"
          @click="$router.push('/language')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/language.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.languagePreference') }}
          </p>
        </div>
			
        <div
          class="item"
          @click="$router.push('article/16')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/gs.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('utils.gs') }}
          </p>
        </div>
						
        <div
          class="item"
          @click="jump('/questions')"
        >
          <div class="item_img">
            <img
              :src="require('../img/user/question.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('user.faq') }}
          </p>
        </div>
        <div
          class="item"
          @click="jump('/kode')"
        >
          <div class="item_img">
            <img
              :src="require('../img/index/lp.jpg')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('utils.kcode') }}
          </p>
        </div>
        <div
          class="item"
          @click="jump(service.ws)"
        >
          <div class="item_img">
            <img
              :src="require('../img/index/ws.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('utils.gfpd') }}
          </p>
        </div>
        <div
          class="item"
          @click="jump(service.tg)"
        >
          <div class="item_img">
            <img
              :src="require('../img/index/tg.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('utils.gfpd') }}
          </p>
        </div>
        <div
          class="item"
          @click="jump(app.url)"
        >
          <div class="item_img">
            <img
              :src="require('../img/index/app.png')"
              alt=""
            >
          </div>
          <p class="item_title">
            {{ $t('index.downApp') }}
          </p>
        </div>
      </div>
    </div>
    <button
      class="basic_btn logout_btn"
      @click="logout"
    >
      {{ $t('user.signOut') }}
    </button>
  </div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import Clipboard from "v-clipboard";
	import {
		Icon,
		Cell,
		CellGroup
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon).use(Clipboard);

	export default {
		name: "User",
		components: {},
		data() {
			return {
				currency: '',
				menus1: [
					// {
					// 	"title": this.$t('savings.savings'),
					// 	"value": '',
					// 	"logo": "user/savings.png",
					// 	"url": "/savings"
					// },
					{
						"title": this.$t('user.vip'),
						"value": '',
						"logo": "user/vip.png",
						"url": "/vip"
					},
					{
						"title": this.$t('user.rewards'),
						"value": '',
						"logo": "user/rewards.png",
						"url": "/rewards"
					},
					{
						"title": this.$t('user.rechargeRecord'),
						"value": '',
						"logo": "user/recharge.png",
						"url": "/recharge/record"
					},
					{
						"title": this.$t('user.withdrawRecord'),
						"value": '',
						"logo": "user/cash.png",
						"url": "/withdraw/record"
					},
					{
						"title": this.$t('user.withdrawAccount'),
						"value": '',
						"logo": "user/moneybag.png",
						"url": "/wallet"
					},{
						"title": this.$t('utils.lunlog19'),
						"value": '',
						"logo": "user/secret.png",
						"url": "/setpwd"
					},
					{
						"title": this.$t('user.languagePreference'),
						"value": '',
						"logo": "user/language.png",
						"url": "/language"
					},
					{
						"title": this.$t('user.faq'),
						"value": '',
						"logo": "user/question.png",
						"url": "/questions"
					}
					// ,
					// {
					// 	"title": this.$t('user.certificationCenter'),
					// 	"value": '',
					// 	"logo": "user/auth1.png",
					// 	"url": "/auth"
					// }
				],
				menus2: [
					// {
					// 	"title": this.$t('user.userAgreement'),
					// 	"logo": "user/agreement.png",
					// 	"url": "/language"
					// },
					// {
					// 	"title": this.$t('user.privacyPolicy'),
					// 	"logo": "user/secret.png",
					// 	"url": "/language"
					// },
					// {
					// 	"title": this.$t('user.languagePreference'),
					// 	"value": '',
					// 	"logo": "user/language.png",
					// 	"url": "/language"
					// },
					// {
					// 	"title": this.$t('user.faq'),
					// 	"value": '',
					// 	"logo": "user/question.png",
					// 	"url": "/questions"
					// }
				],
				data: {},
				fundBalance: 0.00,
				fundBalanceUsd: 0.00,
				money_r:0.00,
				savings: 0.00,
				eye: 1,
				service:'',
				signinStatue:false
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#051C3F');
				plus.navigator.setStatusBarStyle('light');
			}
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
		},
		methods: {
			jump(url) {
				if (url.indexOf('http') == 0) {
					console.log('http');
					window.location.href = url;
				} else {
					this.$router.push(url);
				}
			},
			copy() {
				this.$toast(this.$t('recharge.copySuccess'));
			},services(){
				window.location.href = this.service;
			},
			showMsg() {
				this.$dialog.alert({
					closeOnClickOverlay: true,
					showConfirmButton: false,
					message: "<p style='text-align: left'>" +
						this.$t('user.fundingTips') +
						"</p>",
				}).catch(() => {
					// on close
				});
			},
			signin(){
				if(this.signinStatue){
					this.$toast(this.$t('user.signined'));
					return false;
				}
				this.signinStatue = true;
				Fetch('/user/signin').then((r) => {
					this.$toast(this.$t('user.signinSuccess'));
				});
			},
			start() {
				var isapp = 0;
				if (window.plus) {
					isapp = 1;
				}
				Fetch('/user/info', {
					isapp: isapp
				}).then((r) => {
					this.data = r.data;
					this.fundBalance = r.data.fundBalance;
					this.fundBalanceUsd = r.data.fundBalanceUsd;
					this.money_r = r.data.money_r;
					this.menus1[0]['value'] = r.data.vip_name;
					this.currency = r.data.currency;
					this.signinStatue = r.data.signin;
					this.service = r.data.service;
				});
			},
			logout() {
				localStorage.removeItem('token');
				// 清除 store 中的用户登录状态
				this.$store.commit('setLogout');
				this.$router.replace("/login");
			},
		}
	};
</script>

<style lang="less" scoped>
	.user_wrap {
		padding-bottom: 60px;
		height: 100%;
		min-height: 100vh;
		padding: 16px;
		background-color: var(--bg-primary);
	}

	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;
		background: linear-gradient(to right bottom, rgb(109, 40, 217), rgb(217, 70, 239), rgb(244, 114, 182));
		box-shadow: unset;
		.big_tit{
			left: 50%;
			transform: translateX(-50%);
			color: #FFFFFF;
		}

		.msg {
			position: absolute;
			top: 12px;
			right: 15px;

			img {
				width: 22px;
				height: 22px;
			}
		}
	}
	.top_header_bg{
		//background: #051C3F;
		width: 100%;
		height: 164px;
	}

	.top_header {
		position: relative;
		justify-content: space-between;
		margin-top: -168px;
		border-radius: 5px 5px 0 0;
		box-shadow: unset;
		color: #FFFFFF;
		position: fixed;
		z-index: 10;
		//background: #051C3F;
		width: 100%;
		margin-left: unset;

		.user_detail {
			// width: 100%;
			padding: 28px 15px 22px 20px;
			top: 34px;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.user_header {
				width: 60px;
				height: 60px;
				overflow: hidden;
				border-radius: 50%;
				border: 3px solid rgba(255, 255, 255, 0.3);

				img {
					width: 100%;
					height: 100%;
				}
			}

			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				.user_all {
					// display: flex;
					// justify-content: flex-start;
					// align-items: center;

					.user_nickname {
						line-height: 21px;
						font-size: 18px;
						font-weight: bold;
						margin-top: 2px;
					}

					img {
						width: 22px;
						border-radius: 50%;
						margin-right: 3px;
					}

					.auth {
						justify-content: unset;
						margin-top: 3px;
					}

					.active {
						border: 2px solid #FFEB3B;
					}
				}
			}
		}

		.invite_code {
			margin-right: 30px;
			text-align: center;

			.invite_tips {
				color: #fff;
				margin-bottom: 10px;
			}

			.copy {
				justify-content: space-between;
				font-size: 16px;
				font-weight: bold;

				.copy_img {
					width: 14px;
					height: 14px;
					margin-left: 2px;
				}
			}

		}
	}

	.user_yw {
		position: relative;
		padding: 15px 0;
		margin-bottom: 10px;
		justify-content: space-between;
		text-align: center;

		div {
			width: 33.33%;
		}

		p {
			margin-top: 8px;
		}

		img {
			width: 30px;
			height: 30px;
		}
	}

	.user_menu {
		margin-top: 10px;
		background: #fff;
		border-radius: 16px;
		padding: 6px 0;
	}

	.user_menu_item {
		width: 100%;
		padding: 14px 16px;
		display: flex;
		align-items: center;
		cursor: pointer;
		border-bottom: 1px solid #f5f5f5;
	}

	.user_menu_item:last-child {
		border-bottom: none;
	}

	.user_menu_item .item_icon {
		width: 34px;
		height: 34px;
		margin-right: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.user_menu_item .item_icon img {
		width: 100%;
		height: 100%;
	}

	.user_menu_item .item_title {
		flex: 1;
		font-size: 15px;
		color: #333;
		line-height: 1.2;
	}

	.user_menu_item .item_arrow {
		font-size: 18px;
	}

	.block_div{
		background: unset ;
		width: 96%;
		margin-left: 2%;
		
		padding: 16px 0px;
		
	}

	.money1 {
		margin-bottom: 10px;
		margin-top: -45px;
		padding: 15px;
		justify-content: space-between;

		div:nth-child(1) {
			p:nth-child(1) {
				color: #999;
				margin-bottom: 10px;
			}

			p:nth-child(2) {
				font-size: 18px;
				font-weight: bold;
			}
		}

		div:nth-child(2) {}

		.money_usd {
			margin-top: 10px;
			color: #999;
		}

		.recharge {
			margin-top: 10px;

			p {
				padding: 5px 10px;
				background: #3775f4;
				margin: 0 10px 8px 0;
				color: #FFFFFF;
				border-radius: 8px;
			}

			p:nth-child(2) {
				background: #FF5722;
			}
		}
	}

	.list {
		margin-top: 10px;
		background: #fff;
		img {
			vertical-align: middle;
			height: 30px;
			width: 30px;
			margin-right: 10px;
		}
	}

	.logout_btn {
		width: 80%;
		margin: 15px 10%;
		margin-bottom: 80px;
		color: #fff;
background: #ff7b7b;
	}

	/deep/ .van-cell {
		background: unset;
	}
	.work_box {
		padding: 10px 15px 5px 15px;
		height: auto;
		margin-bottom: 15px;
		
		.flex_center {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
			justify-content: space-between;
		}
		
		.item {
			width: calc(33.333% - 4px);
			text-align: center;
			margin-bottom: 6px;
			flex: 0 0 calc(33.333% - 4px);
			display: flex;
			flex-direction: column;
			align-items: center;
	
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				flex-shrink: 0;
	
				img {
					width: 34px;
					height: 34px;
					padding: 4px;
				}
			}
	
			.item_title {
				width: 100%;
				
				line-height: 16px;
				font-size: 13px;
				color: #fff;
				text-align: center;
				transform: scale(0.85);
				margin-top: 4px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}
	}
</style>
